import { useNavigate, useParams, Outlet } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useStoreHook } from '../Hooks/StoreHook';
import { useOrderTypeContext } from '../Contexts/OrderTypeContext';
import { ORDER_TYPE_DELIVERY, ORDER_TYPE_DIRECT_SALE, ORDER_TYPE_STORE_COUNTER } from '../Utils/Constants/Service';
import { orderTypeAsSlug, orderTypeAsSlugConvert } from '../Utils/Helpers';
import { useCartContext } from '../Contexts/CartContext';
import { useStoreContext } from '../Contexts/StoreContext';
import { ImSpinner8 } from 'react-icons/im';
import { useLoginContext } from '../Contexts/LoginContext';
import { useCheckoutContext } from '../Contexts/CheckoutContext';

const AppRouter = () => {
    const { loadStoreInfo } = useStoreHook();
    const { orderType, setOrderType, setIsStoreCounter, setIsDelivery, setIsDirectSale } = useOrderTypeContext();
    const { setOrder } = useCheckoutContext();
    const { setGuestToken, setToken, setUser } = useLoginContext();
    const { setCartDisplay, setCurrentCart, setCartFinished } = useCartContext();
    const { setTable, setTables } = useStoreContext();
    const navigate = useNavigate();
    const { slug, order_type, table_id } = useParams();
    const [loadingRoute, setLoadingRoute] = useState<boolean>(true);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const storeId = params.get('store_id') || null;
        const storeTableIdByQuery = params.get('store_table_id') ?? table_id ?? null;

        const handleTableIdFromQuery = () => {
            if (storeTableIdByQuery) {
                //* setTimeout necessário pois a inicialização é null no useStoreContext e está em tempo de execução
                setTimeout(() => {
                    setTable(storeTableIdByQuery);
                }, 0);
            }
        }

        const handleNavigation = async () => {
            if (storeId) {
                setLoadingRoute(true);
                try {
                    const response: any = await loadStoreInfo(storeId);
                    setOrderType(ORDER_TYPE_STORE_COUNTER);
                    handleTableIdFromQuery();
                    if (response?.slug) {
                        navigate(`/${orderTypeAsSlug(ORDER_TYPE_STORE_COUNTER)}/${response.slug}`);
                    }
                } finally {
                    setLoadingRoute(false);
                }

            } else {
                if (order_type && Boolean(orderTypeAsSlugConvert(order_type)) && slug) {
                    setLoadingRoute(true);
                    handleTableIdFromQuery();
                    try {
                        const response: any = await loadStoreInfo(slug);
                        if (response) {
                            setOrderType(orderTypeAsSlugConvert(order_type));
                            navigate(`/${orderTypeAsSlug(order_type)}/${response.slug}`);
                        }
                    } catch {
                        navigate('/lojas');
                    } finally {
                        setLoadingRoute(false);
                    }
                } else {
                    navigate('/lojas');
                }
            }
        };
        handleNavigation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const previousOrderTypeRef = useRef(orderType);
    useEffect(() => {
        if (orderType && previousOrderTypeRef?.current !== orderType) {
            if (orderType === ORDER_TYPE_STORE_COUNTER) {
                setUser(null);
                setToken(null);
                setGuestToken(null);
                setCurrentCart(null);
            } else {
                setTable(null);
                setCartDisplay(null);
                setCartFinished(null);
                setTables(null);
            }
            setOrder(null);
            setIsStoreCounter(orderType === ORDER_TYPE_STORE_COUNTER);
            setIsDelivery(orderType === ORDER_TYPE_DELIVERY);
            setIsDirectSale(orderType === ORDER_TYPE_DIRECT_SALE);
            previousOrderTypeRef.current = orderType
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderType]);

    return (
        <main>
            {loadingRoute
                ? <div className='flex items-center justify-center w-full h-dvh text-sm text-gray-500'>
                    <div className='flex items-center gap-1'><ImSpinner8 className="animate-spin" /><span>Carregando informações da loja</span></div>
                </div>
                : <Outlet />
            }
        </main>
    )
};

export default AppRouter;
